import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { getAllUsers } from "../../utils/account";
import Textfield from "../InviteUserModal/Textfield";
import ErrorText from "../commonComponents/ErrorTextContainer";
import { formatDateToHumanReadable } from "../../utils/utils";

import "./style.css";

export default function Photogenix() {
  const navigate = useNavigate();
  const globalReducer = useSelector((store: any) => store.globalReducer);

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <div>
      <div className="section-header">Photogenix</div>
      <div className="photogenix-links-container">
        <div
          onClick={() => handleNavigate("/photogenix/models")}
          className="link-item"
        >
          Models
        </div>
        <div
          onClick={() => handleNavigate("/photogenix/backgrounds")}
          className="link-item"
        >
          Backgrounds
        </div>
        <div
          onClick={() => handleNavigate("/photogenix/stylings")}
          className="link-item"
        >
          Stylings
        </div>
        <div
          onClick={() => handleNavigate("/photogenix/ad-stylings")}
          className="link-item"
        >
          Ad-Stylings
        </div>
        <div
          onClick={() => handleNavigate("/photogenix/product-bgs")}
          className="link-item"
        >
          Product backgrounds
        </div>
        <div
          onClick={() => handleNavigate("/photogenix/poses")}
          className="link-item"
        >
          Poses
        </div>
      </div>
    </div>
  );
}
